export interface PrimaryActionStateOptions {
  isLocallyValid: boolean
  isBusy: boolean
  isProcessing: boolean
}

export interface PrimaryActionState {
  disabled: boolean
  softDisabled: boolean
  showSpinner: boolean
}

/** Keeps local validation feedback clickable while locking duplicate or processing actions. */
export const resolvePrimaryActionState = ({
  isLocallyValid,
  isBusy,
  isProcessing,
}: PrimaryActionStateOptions): PrimaryActionState => ({
  disabled: isBusy || isProcessing,
  softDisabled: !isProcessing && !isLocallyValid,
  showSpinner: isProcessing,
})
